import { useCallback, useState } from 'react';

import { useAuthContext } from '@/hooks/auth.store';

export interface UseWeeklyUpdateAssetsReturn {
  accessToken: string | null;
  microsoftOboAssertion: string | null;
  sharepointReady: boolean;
  refreshMicrosoftOboAssertion: () => Promise<string | null>;
  linkedDocCardIds: string[];
  assetModalOpen: boolean;
  browseOpen: boolean;
  openAssetModal: () => void;
  closeAssetModal: () => void;
  openBrowse: () => void;
  closeBrowse: () => void;
  addCard: (cardId: string) => void;
  removeCard: (cardId: string) => void;
}

export function useWeeklyUpdateAssets(): UseWeeklyUpdateAssetsReturn {
  const { accessToken, microsoftOboAssertion, refreshMicrosoftOboAssertion } = useAuthContext();
  const sharepointReady = !!microsoftOboAssertion;

  const [linkedDocCardIds, setLinkedDocCardIds] = useState<string[]>([]);
  const [assetModalOpen, setAssetModalOpen] = useState(false);
  const [browseOpen, setBrowseOpen] = useState(false);

  const openAssetModal = useCallback(() => setAssetModalOpen(true), []);
  const closeAssetModal = useCallback(() => setAssetModalOpen(false), []);

  const openBrowse = useCallback(() => {
    setAssetModalOpen(false);
    setBrowseOpen(true);
  }, []);

  const closeBrowse = useCallback(() => setBrowseOpen(false), []);

  const addCard = useCallback((cardId: string) => {
    setLinkedDocCardIds((prev) => (prev.includes(cardId) ? prev : [...prev, cardId]));
  }, []);

  const removeCard = useCallback((cardId: string) => {
    setLinkedDocCardIds((prev) => prev.filter((id) => id !== cardId));
  }, []);

  return {
    accessToken,
    microsoftOboAssertion,
    sharepointReady,
    refreshMicrosoftOboAssertion,
    linkedDocCardIds,
    assetModalOpen,
    browseOpen,
    openAssetModal,
    closeAssetModal,
    openBrowse,
    closeBrowse,
    addCard,
    removeCard,
  };
}
